import {MapContainer, TileLayer} from 'react-leaflet'
import {useContext, useEffect, useRef} from 'react'
import {MapContext} from '../context/MapContext'
import UpdateMapView from './UpdateMapView'
import LocationsMarkers from "./LocationsMarkers"
import Panel from "./Panel";
import CurrentLocation from "./CurrentLocation";
import NavigationRoute from "./NavigationRoute";
import FeaturedMarkerGlobe from "./FeaturedMarkerGlobe";
import MapTilePreloader from "./MapTilePreloader";

const mapTileUrl = "https://api.mapbox.com/styles/v1/jopzik/clfolkn04000801poy90ajdwi/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoiam9wemlrIiwiYSI6ImNsNGs5dTQ1MjBmcDEzanAweWloMGk0cHYifQ.HpWeVuJf0FbJ5_FFHMqV5Q"

const Map = () => {
  const {
    locations,
    mapCoords,
    mapFocus,
    panelStatus,
    featuredMarker,
    currentLocation
  } = useContext(MapContext)
  const map = useRef()
  const previousFeaturedMarker = useRef(featuredMarker)

  useEffect(() => {
    document.body.classList.add('show-tooltips')
  }, [map])

  useEffect(() => {
    document.body.classList[featuredMarker !== null ? 'add' : 'remove']('featured-selected')
  }, [featuredMarker])

  useEffect(() => {
    const isReturningFromSelection = previousFeaturedMarker.current !== null && featuredMarker === null
    previousFeaturedMarker.current = featuredMarker

    if (!isReturningFromSelection) return

    document.body.classList.add('markers-returning')
    const timeout = window.setTimeout(() => {
      document.body.classList.remove('markers-returning')
    }, 1100)

    return () => {
      window.clearTimeout(timeout)
      document.body.classList.remove('markers-returning')
    }
  }, [featuredMarker])

  return (
    <>
      <MapContainer
        ref={map}
        center={mapCoords}
        maxZoom={20}
        attributionControl={false}
        zoomAnimation={false}
        fadeAnimation={false}
        scrollWheelZoom={true}
      >
        <TileLayer
          maxZoom={20}
          keepBuffer={6}
          updateWhenIdle
          url={mapTileUrl}
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <MapTilePreloader url={mapTileUrl}/>
        <UpdateMapView coords={mapCoords} focus={mapFocus} panelStatus={panelStatus}/>
        <NavigationRoute/>
        {currentLocation && <CurrentLocation/>}
        <LocationsMarkers locations={locations}/>
      </MapContainer>
      <FeaturedMarkerGlobe/>
      <Panel locations={locations}/>
    </>
  )
}

export default Map
